/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/victory-errorbar/~/lodash/_freeGlobal.js
// module id = ./node_modules/victory-errorbar/node_modules/lodash/_freeGlobal.js
// module chunks = 1